module.exports = "breadcrumb-arrow-small"